<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on: onTooltip }">
        <v-btn
          icon
          v-on="{ ...onTooltip, click: open }"
          :disabled="sendDisabled"
        >
          <v-icon>mdi-mail</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('recherche.rappelLogin.menu.title') }}</span>
    </v-tooltip>

    <v-dialog persistent v-model="showDialog" max-width="750px">
      <v-card>
        <v-card-title class="secondary white--text">
          <v-icon color="white">mdi-mail</v-icon>
          {{ $t('recherche.rappelLogin.dialog.title') }}
        </v-card-title>
        <v-card-text class="body-1">
          <p class="pt-4">
            {{ $tc('recherche.rappelLogin.dialog.text', nbContacts) }}
          </p>
          <p>
            {{ $t('recherche.rappelLogin.dialog.more') }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="send">
            {{ $t('button.send') }}
          </v-btn>
          <v-btn @click="close" text>
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import toasted from '@/utils/toasted';

export default {
  props: {
    recherche: {
      type: Array,
    },
    nbContacts: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // Affichage de la boîte de dialogue
      showDialog: false,
    };
  },

  computed: {
    sendDisabled() {
      return this.nbContacts == 0 || !this.recherche;
    },
  },

  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    send() {
      this.close();
      this.$api('rappel-login/personne-physique')
        .post({
          contactIds: this.recherche.map(c => c.id),
        })
        .then(() => {
          toasted.info('recherche.rappelLogin.dialog.succes');
        });
    },
  },
};
</script>
